import AuthenticationService from './../../services/AuthenticationService'
import store from '@/store'
import alerts from '@/alerts/alert'
import router from '@/router'

const sidebar = {
  namespaced: true,
  state: {
    sidebar: {}
  },
  getters: {
    getSidebar (state) {
      return state.sidebar
    }
  },
  mutations: {
    SET_SIDEBAR (state, sidebar) {
      state.sidebar = sidebar
    }
  },
  actions: {
    reqSidebar ({ commit }) {
      return AuthenticationService.get('menus/menu').then(({ data }) => {
        const rt = router.currentRoute
        const menuNew = data.data
        menuNew.forEach((element, i) => {
          if (element.slug === 'dropdown') {
            const groupMenusHref = element.elements.find(el => el.href === rt.path)
            if (groupMenusHref) {
              menuNew[i].isActive = true
            } else {
              menuNew[i].isActive = false
            }
          }
        })
        commit('SET_SIDEBAR', menuNew)
      }).catch(error => {
        alerts.sweetalertToast('error', error.response.data.message || error.response.data.error)
        commit('SET_LOADING', false)
        if (error.response.data.message === 'Token is Expired' || error.response.data.error === 'Token is Expired') {
          store.dispatch('auth/reqLogout')
          router.push({ name: 'PublicPage' })
        }
      })
    },
    setIsAactiveFalse ({ commit, state }) {
      const menuNew = state.sidebar
      menuNew.forEach((element, i) => {
        if (element.slug === 'dropdown') {
          menuNew[i].isActive = false
        }
      })
      commit('SET_SIDEBAR', menuNew)
    }
  }
}

export default sidebar
